import * as React from "react";
const DropDownIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A2A9BF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m7 15 5-6 5 6"
    />
  </svg>
);
export default DropDownIcon;
